import { useState } from 'react';
import { RudderstackTracker } from '../../../../infra/observability/rudderstack/rudderstack';
import { REPORTING_BOT_CUSTOM_QUERY_ENTERED } from '../../../../infra/observability/rudderstack/events';
export var useChatInput = function (_a) {
    var onMessageSubmit = _a.onMessageSubmit;
    var _b = useState(''), inputValue = _b[0], setInputValue = _b[1];
    var handleInputChange = function (e) {
        setInputValue(e.target.value);
    };
    var handleSubmit = function () {
        if (inputValue.trim() && onMessageSubmit) {
            onMessageSubmit(inputValue.trim());
            setInputValue('');
            RudderstackTracker.getInstance().track(REPORTING_BOT_CUSTOM_QUERY_ENTERED);
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };
    return { inputValue: inputValue, handleInputChange: handleInputChange, handleSubmit: handleSubmit, handleKeyDown: handleKeyDown };
};
